// extracted by mini-css-extract-plugin
export default {"loadingOverlay":"style_loadingOverlay__0Dwaw","loadingContent":"style_loadingContent__1Xi2q","spinner":"style_spinner__nf2S6","spin":"style_spin__ASQeL"};